export const listItemPhotoFragment = `
  fragment listItemPhotoFragment on Photo {
    main: url (width: 800, height: 600)
    thumb: url (width: 360, height: 360)
  }  
`;
